import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../handlers'

export const useActivityQuery = () => {
  const godModeState = getGodModeOptionsState()

  return useGenericRequestHandler({
    route: 'a/activity',
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  })
}
